
import SettingsIcon from '@mui/icons-material/Settings';
const MendetoryIcon =()=>{

    const iconStyle = { height: "12px", width: "12px", color: "#A80019", marginBottom: "5px" }
    return( 
    <SettingsIcon      style={{ visibility:"visible"  }} sx={iconStyle} />
    
    )
   
}

export default MendetoryIcon;